<template>
  <div class="contact-page">
    <!-- Intro Section -->
    <section class="contact-intro position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="contact-intro-content text-center">
              <div class="contact-section-label">
                <h4>Get In Touch</h4>
              </div>
              <div class="contact-main-title">
                <h2>Contact Us</h2>
              </div>
              <div class="contact-description">
                <p>Ready to start your next project? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Form & Info Section -->
    <section class="contact-form-info position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>

      <div class="header-container">
        <div class="row">
          <!-- Contact Form -->
          <div class="col-lg-8 col-md-12 mb-5">
            <div class="contact-form-section">
              <div class="form-header">
                <h3>Send us a Message</h3>
                <p>Fill out the form below and we'll get back to you within 24 hours. Auto-response enabled.</p>
              </div>
              <form @submit.prevent="submitContact" class="contact-form">
                <div class="form-row">
                  <div class="form-group">
                    <label for="name">Name *</label>
                    <input 
                      type="text" 
                      id="name" 
                      v-model="contactForm.name" 
                      placeholder="Your Full Name" 
                      required
                    >
                  </div>
                  <div class="form-group">
                    <label for="email">Email *</label>
                    <input 
                      type="email" 
                      id="email" 
                      v-model="contactForm.email" 
                      placeholder="your.email@example.com" 
                      required
                    >
                  </div>
                </div>
                <div class="form-group">
                  <label for="subject">Subject *</label>
                  <input 
                    type="text" 
                    id="subject" 
                    v-model="contactForm.subject" 
                    placeholder="What's this about?" 
                    required
                  >
                </div>
                <div class="form-group">
                  <label for="message">Message *</label>
                  <textarea 
                    id="message" 
                    v-model="contactForm.message" 
                    placeholder="Tell us about your project, requirements, or any questions you have..." 
                    rows="6" 
                    required
                  ></textarea>
                </div>
                <div class="form-submit">
                  <button type="submit" class="submit-btn">
                    <i class="icon-02"></i> Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Contact Information -->
          <div class="col-lg-4 col-md-12">
            <div class="contact-info-section">
              <div class="info-header">
                <h3>Contact Information</h3>
                <p>Get in touch with us through any of these channels.</p>
              </div>
              
              <div class="contact-info-list">
                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="icon-03"></i>
                  </div>
                  <div class="info-content">
                    <h4>Address</h4>
                    <p>Sogdo HQ + Branches in MP & Bihar<br>Innovation District<br>San Francisco, CA 94105<br>United States</p>
                  </div>
                </div>

                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="icon-04"></i>
                  </div>
                  <div class="info-content">
                    <h4>Phone</h4>
                    <p>[Toll-free]<br>Mon-Fri, 9AM-6PM EST</p>
                  </div>
                </div>

                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="icon-05"></i>
                  </div>
                  <div class="info-content">
                    <h4>Email</h4>
                    <p>[support@sogdo.com]<br>We'll respond within 24 hours</p>
                  </div>
                </div>

                <div class="contact-info-item">
                  <div class="info-icon">
                    <i class="icon-01"></i>
                  </div>
                  <div class="info-content">
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM<br>Saturday: 10:00 AM - 4:00 PM<br>Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <div class="social-links">
                <h4>Follow Us</h4>
                <div class="social-icons">
                  <a href="#" class="social-link">
                    <i class="icon-02"></i>
                  </a>
                  <a href="#" class="social-link">
                    <i class="icon-03"></i>
                  </a>
                  <a href="#" class="social-link">
                    <i class="icon-04"></i>
                  </a>
                  <a href="#" class="social-link">
                    <i class="icon-05"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <section class="map-section position-relative">
      <div class="map-container">
        <div class="map-header">
          <h3>Find Us</h3>
          <p>Visit our office in the heart of the Innovation District</p>
        </div>
        <div class="map-embed">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.835434509374!2d-122.3964157846814!3d37.774929279759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808c4c8b8b8b%3A0x8b8b8b8b8b8b8b8b!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" 
            width="100%" 
            height="400" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div class="map-info">
          <div class="map-details">
            <h4>Our Location</h4>
            <p>Located in the heart of San Francisco's Innovation District, our office is easily accessible by public transportation and offers convenient parking options.</p>
            <div class="location-features">
              <div class="feature-item">
                <i class="icon-03"></i>
                <span>Public Transit Access</span>
              </div>
              <div class="feature-item">
                <i class="icon-04"></i>
                <span>Parking Available</span>
              </div>
              <div class="feature-item">
                <i class="icon-05"></i>
                <span>Wheelchair Accessible</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action Section -->
    <section class="contact-cta position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="cta-content text-center border rounded-4 p-5">
              <div class="cta-title">
                <h2>Ready to Start Your Project?</h2>
              </div>
            
              <div class="cta-buttons">
                <a href="mailto:say@sogdo.com?subject=Resume Submission&body=Please find my resume attached." class="cta-btn primary-btn">
                  <i class="icon-04"></i> Send Resume to say@sogdo.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import WOW from 'wowjs'

export default {
  name: 'ContactPage',
  setup() {
    const contactForm = ref({
      name: '',
      email: '',
      subject: '',
      message: ''
    })

    const submitContact = () => {
      // Handle form submission
      console.log('Contact form submitted:', contactForm.value)
      
      // Show success message
      alert('Thank you for your message! We\'ll get back to you within 24 hours.')
      
      // Reset form
      contactForm.value = {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }

    onMounted(() => {
      // Initialize WOW.js
      new WOW.WOW({
        mobile: false
      }).init()
    })

    return {
      contactForm,
      submitContact
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Global Styles */
body {
  font-family: 'Open Sans', sans-serif;
  line-height: 1.6;
  color: #333;
}

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  right: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  bottom: 20%;
  left: 8%;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-3 {
  top: 30%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-4 {
  top: 15%;
  right: 15%;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Intro Section */
.contact-intro {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.contact-intro-content {
  position: relative;
  z-index: 2;
}

.contact-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.contact-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.contact-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Contact Form & Info Section */
.contact-form-info {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.contact-form-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 40px;
  position: relative;
  z-index: 2;
}

.form-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.form-header p {
  font-size: 16px;
  color: #fff;
  margin-bottom: 30px;
  opacity: 0.8;
}

.contact-form {
  position: relative;
  z-index: 2;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 15px 20px;
  border: 1px solid rgba(246, 236, 79, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;
  font-family: 'Open Sans', sans-serif;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #F6EC4F;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(246, 236, 79, 0.1);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.form-submit {
  margin-top: 30px;
}

.submit-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Archivo', sans-serif;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(246, 236, 79, 0.3);
}

/* Contact Info Section */
.contact-info-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 40px;
  position: relative;
  z-index: 2;
  height: fit-content;
}

.info-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.info-header p {
  font-size: 16px;
  color: #fff;
  margin-bottom: 30px;
  opacity: 0.8;
}

.contact-info-list {
  margin-bottom: 30px;
}

.contact-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}

.info-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.info-icon i {
  font-size: 20px;
  color: #00061A;
}

.info-content h4 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.info-content p {
  font-size: 14px;
  color: #fff;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
}

.social-links h4 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(246, 236, 79, 0.1);
  border: 1px solid rgba(246, 236, 79, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F6EC4F;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #F6EC4F;
  color: #00061A;
  transform: translateY(-2px);
}

/* Map Section */
.map-section {
  background: #f8f9fa;
  padding: 60px 0;
}

.map-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.map-header {
  text-align: center;
  margin-bottom: 40px;
}

.map-header h3 {
  font-size: 32px;
  font-weight: 700;
  color: #00061A;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.map-header p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.map-embed {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.map-info {
  background: #fff;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.map-details h4 {
  font-size: 20px;
  font-weight: 600;
  color: #00061A;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.map-details p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.location-features {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.feature-item i {
  color: #F6EC4F;
  font-size: 16px;
}

.feature-item span {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* Call to Action Section */
.contact-cta {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-description p {
  font-size: 18px;
  color: #fff;
  max-width: 600px;
  margin: 0 auto 40px;
  line-height: 1.8;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.primary-btn {
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(246, 236, 79, 0.3);
}

.secondary-btn {
  background: transparent;
  color: #F6EC4F;
  border-color: #F6EC4F;
}

.secondary-btn:hover {
  background: #F6EC4F;
  color: #00061A;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 767px) {
  .contact-main-title h2,
  .cta-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .contact-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .contact-form-section,
  .contact-info-section {
    padding: 30px 20px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  .contact-info-item {
    flex-direction: column;
    text-align: center;
  }
  
  .info-icon {
    margin: 0 auto 15px;
  }
  
  .social-icons {
    justify-content: center;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
  
  .location-features {
    flex-direction: column;
    gap: 15px;
  }
}

@media (max-width: 399px) {
  .see__pad {
    padding: 60px 0;
  }
  
  .contact-main-title h2,
  .cta-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
  
  .contact-form-section,
  .contact-info-section {
    padding: 20px 15px;
  }
}

/* Update CTA section background to white */
.contact-page .contact-cta {
  background: #ffffff !important;
}

.contact-page .contact-cta .pattern-layer {
  display: none !important;
}

/* Update text color for Send Resume title */
.contact-page .contact-cta .cta-title h2 {
  color: #2c3e50 !important;
  font-weight: 700;
}
</style>